/**
 * Device-local memory of the challenge link this user is currently offering.
 *
 * Needed because creating a link is normally followed by LEAVING the app (to
 * paste it into WhatsApp); a mobile browser may drop the tab in the meantime.
 * On the next load the id is used to re-fetch the invite and put the "waiting
 * for your friend" overlay back — otherwise the challenger has a live link they
 * can no longer see, share again or cancel.
 *
 * Cleared when the overlay is closed or the link is cancelled.
 */

const STORAGE_KEY = 'draughts-challenge-link';

export function getStoredChallengeLinkId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setStoredChallengeLinkId(id: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // Private mode / storage disabled — the overlay simply won't be restored.
  }
}

export function clearStoredChallengeLinkId(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to do.
  }
}
